<template>
  <v-window-item value="educations">
    <v-card-text>
      <v-card class="bg-white" variant="outlined">
        <v-card-title class="text-subtitle-1">
          <v-icon class="me-1" size="small">mdi-school</v-icon>
          Educational Information
        </v-card-title>

        <v-card-text>
          <v-form @submit.prevent="submit">
            <div class="education-table">
              <v-row class="education-row education-header ma-0 d-flex align-center">
                <v-col cols="12" md="1" class="py-1 ma-0">Level</v-col>
                <v-col cols="12" md="2" class="py-1 ma-0">Examination</v-col>
                <v-col cols="12" md="1" class="py-1 ma-0">Year</v-col>
                <v-col cols="12" md="2" class="py-1 ma-0">Subject</v-col>
                <v-col cols="12" md="1" class="py-1 ma-0">Board</v-col>
                <v-col cols="12" md="2" class="py-1 ma-0">Institution</v-col>
                <v-col cols="12" md="1" class="py-1 ma-0">Result</v-col>
                <v-col cols="12" md="1" class="py-1 ma-0">Marks/GPA</v-col>
                <v-col cols="12" md="1" class="py-1 ma-0">Actions</v-col>
              </v-row>

              <v-row
                v-for="(level, index) in educationLevels"
                :key="level.value"
                class="education-row ma-0"
                :class="{ 'education-row-alt': index % 2 }"
              >
                <v-col cols="12" md="1" class="d-flex align-center">
                  {{ level.title }}
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="educationalInfo[level.value].examination"
                    :items="examinationOptions"
                    item-title="text"
                    item-value="value"
                    label="Examination"
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    hide-details
                    clearable
                  
                      :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                </v-col>
                <v-col cols="12" md="1">
                  <v-select
                    v-model="educationalInfo[level.value].passing_year"
                    :items="yearOptions"
                    item-title="text"
                    item-value="value"
                    label="Year"
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    hide-details
                    clearable
                  
                      :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="educationalInfo[level.value].subject_group"
                    label="Subject"
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    hide-details
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="1">
                  <v-select
                    v-model="educationalInfo[level.value].board"
                    :items="boardOptions"
                    item-title="text"
                    item-value="value"
                    label="Board"
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    hide-details
                    clearable
                  
                      :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field
                    v-model="educationalInfo[level.value].institution"
                    label="Institution"
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    hide-details
                    clearable
                  />
                </v-col>
                <v-col cols="12" md="1">
                  <v-select
                    v-model="educationalInfo[level.value].result"
                    :items="resultOptions"
                    item-title="text"
                    item-value="value"
                    label="Result"
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    hide-details
                    clearable
                  
                      :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                </v-col>
                <v-col cols="12" md="1">
                  <v-text-field
                    v-model="educationalInfo[level.value].marks_gpa"
                    label="Marks/GPA"
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    hide-details
                    clearable
                  />
                </v-col>
              </v-row>

              <v-row
                v-for="(degree, index) in educationalInfo.additional_degrees"
                :key="`additional-${index}`"
                class="education-row education-row-alt ma-0"
              >
                <v-col cols="12" md="1" class="d-flex align-center">
                  Masters {{ index + 2 }}
                </v-col>
                <v-col cols="12" md="2">
                  <v-select
                    v-model="degree.examination"
                    :items="examinationOptions"
                    item-title="text"
                    item-value="value"
                    label="Examination"
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    hide-details
                    clearable
                  
                      :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                </v-col>
                <v-col cols="12" md="1">
                  <v-select
                    v-model="degree.passing_year"
                    :items="yearOptions"
                    item-title="text"
                    item-value="value"
                    label="Year"
                    variant="outlined"
                    density="compact"
                    bg-color="grey-lighten-4"
                    hide-details
                    clearable
                  
                      :menu-props="{ contentClass: 'my-custom-dropdown' }"
/>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field v-model="degree.subject_group" label="Subject" variant="outlined" density="compact" bg-color="grey-lighten-4" hide-details clearable />
                </v-col>
                <v-col cols="12" md="1">
                  <v-select v-model="degree.board" :items="boardOptions" item-title="text" item-value="value" label="Board" variant="outlined" density="compact" bg-color="grey-lighten-4" hide-details clearable  :menu-props="{ contentClass: 'my-custom-dropdown' }"/>
                </v-col>
                <v-col cols="12" md="2">
                  <v-text-field v-model="degree.institution" label="Institution" variant="outlined" density="compact" bg-color="grey-lighten-4" hide-details clearable />
                </v-col>
                <v-col cols="12" md="1">
                  <v-select v-model="degree.result" :items="resultOptions" item-title="text" item-value="value" label="Result" variant="outlined" density="compact" bg-color="grey-lighten-4" hide-details clearable  :menu-props="{ contentClass: 'my-custom-dropdown' }"/>
                </v-col>
                <v-col cols="12" md="1">
                  <v-text-field v-model="degree.marks_gpa" label="Marks/GPA" variant="outlined" density="compact" bg-color="grey-lighten-4" hide-details clearable />
                </v-col>
                <v-col cols="12" md="1" class="d-flex align-center">
                  <v-btn color="error" icon="mdi-delete" size="small" variant="outlined" @click="removeAdditionalDegree(index)">

                  </v-btn>
                </v-col>
              </v-row>
            </div>

            <v-btn class="mt-3" color="primary" variant="tonal" type="button" @click="addAdditionalDegree">
              <v-icon start>mdi-plus</v-icon>
              Add More
            </v-btn>

            <v-row class="mt-2">
              <v-col cols="12" md="6">
                <v-file-input
                  v-model="certificateFile"
                  label="Certificate File"
                  variant="outlined"
                  density="compact"
                  bg-color="grey-lighten-4"
                  accept=".pdf,.jpg,.jpeg,.png"
                  show-size
                  clearable
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-file-input
                  v-model="transcriptFile"
                  label="Transcript File"
                  variant="outlined"
                  density="compact"
                  bg-color="grey-lighten-4"
                  accept=".pdf,.jpg,.jpeg,.png"
                  show-size
                  clearable
                />
              </v-col>
            </v-row>

            <v-card-actions class="px-0">
              <v-spacer />
              <v-btn color="primary" type="submit" variant="flat" :loading="submitting">
                Update
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-window-item>
</template>

<script>
import { useStore } from 'vuex';
import { ref, watch } from 'vue';
import { toast } from 'vue3-toastify';

const createEducation = () => ({
  id: null,
  examination: '',
  passing_year: '',
  subject_group: '',
  board: '',
  institution: '',
  result: '',
  marks_gpa: ''
});

export default {
  props: {
    userEducationInfoData: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    const store = useStore();
    const submitting = ref(false);
    const employeeId = ref(null);
    const certificateFile = ref(null);
    const transcriptFile = ref(null);
    const educationalInfo = ref({
      below_ssc: createEducation(),
      ssc_equivalent: createEducation(),
      hsc_equivalent: createEducation(),
      graduation: createEducation(),
      masters: createEducation(),
      additional_degrees: []
    });

    const educationLevels = [
      { title: 'Below SSC', value: 'below_ssc' },
      { title: 'SSC/Equivalent', value: 'ssc_equivalent' },
      { title: 'HSC/Equivalent', value: 'hsc_equivalent' },
      { title: 'Graduation', value: 'graduation' },
      { title: 'Masters', value: 'masters' }
    ];

    const yearOptions = [];
    for (let year = new Date().getFullYear(); year >= 1950; year -= 1) {
      yearOptions.push({ text: String(year), value: year });
    }

    const examinationOptions = [
      { text: 'S.S.C', value: 'ssc' },
      { text: 'H.S.C', value: 'hsc' },
      { text: 'Bachelor', value: 'bachelor' },
      { text: 'Master', value: 'master' },
      { text: 'Ph.D', value: 'phd' },
      { text: 'Diploma', value: 'diploma' },
      { text: 'Certificate', value: 'certificate' }
    ];

    const boardOptions = [
      { text: 'Dhaka Board', value: 'dhaka' },
      { text: 'Chittagong Board', value: 'chittagong' },
      { text: 'Rajshahi Board', value: 'rajshahi' },
      { text: 'Sylhet Board', value: 'sylhet' },
      { text: 'Barisal Board', value: 'barisal' },
      { text: 'Comilla Board', value: 'comilla' },
      { text: 'Jessore Board', value: 'jessore' },
      { text: 'Dinajpur Board', value: 'dinajpur' },
      { text: 'Mymensingh Board', value: 'mymensingh' }
    ];

    const resultOptions = [
      { text: 'First Class', value: 'first_class' },
      { text: 'Second Class', value: 'second_class' },
      { text: 'Third Class', value: 'third_class' },
      { text: 'Pass', value: 'pass' },
      { text: 'A+', value: 'a_plus' },
      { text: 'A', value: 'a' },
      { text: 'A-', value: 'a_minus' },
      { text: 'B+', value: 'b_plus' },
      { text: 'B', value: 'b' },
      { text: 'B-', value: 'b_minus' },
      { text: 'C+', value: 'c_plus' },
      { text: 'C', value: 'c' },
      { text: 'D', value: 'd' },
      { text: 'F', value: 'f' }
    ];

    const resetEducationalInfo = () => {
      educationalInfo.value = {
        below_ssc: createEducation(),
        ssc_equivalent: createEducation(),
        hsc_equivalent: createEducation(),
        graduation: createEducation(),
        masters: createEducation(),
        additional_degrees: []
      };
    };

    const mapEducationalInfo = (records) => {
      resetEducationalInfo();
      (records || []).forEach((record) => {
        employeeId.value = record.employee_id || employeeId.value;
        const mapped = {
          ...createEducation(),
          id: record.id,
          examination: record.examination || '',
          passing_year: record.passing_year || '',
          subject_group: record.subject_group || '',
          board: record.board || '',
          institution: record.institution || '',
          result: record.result || '',
          marks_gpa: record.marks_gpa || ''
        };

        if (record.level === 'additional_masters') {
          educationalInfo.value.additional_degrees.push(mapped);
        } else if (educationalInfo.value[record.level]) {
          educationalInfo.value[record.level] = mapped;
        }
      });
    };

    watch(
      () => props.userEducationInfoData,
      (data) => mapEducationalInfo(data),
      { immediate: true, deep: true }
    );

    const addAdditionalDegree = () => {
      educationalInfo.value.additional_degrees.push(createEducation());
    };

    const removeAdditionalDegree = (index) => {
      educationalInfo.value.additional_degrees.splice(index, 1);
    };

    const submit = async () => {
      submitting.value = true;
      try {
        const files = {};
        const certificate = Array.isArray(certificateFile.value)
          ? certificateFile.value[0]
          : certificateFile.value;
        const transcript = Array.isArray(transcriptFile.value)
          ? transcriptFile.value[0]
          : transcriptFile.value;

        if (certificate) files.certificateFile = certificate;
        if (transcript) files.transcriptFile = transcript;

        const response = await store.dispatch('educationalInfo/saveEmployeeEducationalInfo', {
          employeeId: employeeId.value,
          educationalData: {
            below_ssc: educationalInfo.value.below_ssc,
            ssc_equivalent: educationalInfo.value.ssc_equivalent,
            hsc_equivalent: educationalInfo.value.hsc_equivalent,
            graduation: educationalInfo.value.graduation,
            masters: educationalInfo.value.masters,
            additional_degrees: educationalInfo.value.additional_degrees
          },
          files
        });

        toast.success(response?.message || 'Educational information updated successfully', { timeout: 3000 });
      } catch (error) {
        toast.error(error.response?.data?.message || 'Failed to update educational information');
      } finally {
        submitting.value = false;
      }
    };

    return {
      educationalInfo,
      educationLevels,
      examinationOptions,
      yearOptions,
      boardOptions,
      resultOptions,
      certificateFile,
      transcriptFile,
      submitting,
      addAdditionalDegree,
      removeAdditionalDegree,
      submit
    };
  }
};
</script>

<style scoped>
.education-table {
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
}

.education-row {
  min-width: 1100px;
  border-bottom: 1px solid #f0f0f0;
}

.education-row-alt {
  background-color: #fafafa;
}

.education-header {
  background-color: #f8f9fa;
  font-size: 0.8rem;
  font-weight: 700;
}

.education-row > .v-col {
  padding: 8px;
}
</style>
